/**
 * Homepage + physical-therapy rebuild flag (PRD REQ-ROL2-01).
 * Set NEXT_PUBLIC_SITEGLUE_LANDING_REDESIGN=0 to restore the configurator homepage
 * and the previous industry template without a code revert.
 * Default is the redesigned landing page.
 */
export function isSiteGlueLandingRedesignEnabled(): boolean {
  return process.env.NEXT_PUBLIC_SITEGLUE_LANDING_REDESIGN !== "0";
}
